import { isNullish } from '@witmetrics/utils/misc';
import { API } from '@/api';

export const classes = {
  button:
    'flex items-center gap-1.5 rounded-full border border-black/10 bg-transparent px-3 py-1.5 text-sm font-bold text-taupe-2 transition-colors hover:bg-black/5 dark:border-white/10 dark:text-mauve-2 dark:hover:bg-white/5',
  icon: 'text-lg',
  balance: 'tabular-nums',
};

export function formatCredits(balance: number | undefined) {
  if (isNullish(balance)) return '—';
  return balance.toLocaleString('en-US');
}

export async function fetchPracticeBalance(practiceId: number) {
  const { balance } =
    await API.Practices.fetchPracticeCreditBalance(practiceId);
  return balance;
}

export async function fetchLabBalance(labId: number) {
  const { balance } = await API.Labs.fetchLabCreditBalance(labId);
  return balance;
}
